import React from "react";

/**
 * Elegant logo matching the cursive "av" style from reference image
 * Professional astrology branding
 */
const LogoSVG = ({ height = 52, className = "" }) => (
  <svg
    width={height * 4.2}
    height={height}
    viewBox="0 0 220 52"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Astrologija v Vortexu"
  >
    <defs>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Great+Vibes&family=Playfair+Display:wght@400;600&display=swap');
        `}
      </style>
    </defs>

    {/* Elegant cursive "av" */}
    <text
      x="10"
      y="30"
      fontFamily="'Great Vibes', 'Brush Script MT', cursive"
      fontSize="38"
      fontWeight="400"
      fill="#333"
      style={{ letterSpacing: "2px" }}
    >
      av
    </text>

    {/* Decorative line above */}
    <path
      d="M 10 8 Q 50 6, 90 8"
      stroke="#999"
      strokeWidth="0.5"
      fill="none"
      opacity="0.6"
    />

    {/* Decorative line below */}
    <path
      d="M 10 38 Q 50 40, 90 38"
      stroke="#999"
      strokeWidth="0.5"
      fill="none"
      opacity="0.6"
    />

    {/* "ASTROLOGIJA v VORTEXU" text below in small caps */}
    <text
      x="10"
      y="46"
      fontFamily="'Playfair Display', 'Merriweather', serif"
      fontSize="6.5"
      fontWeight="400"
      fill="#666"
      letterSpacing="1.5"
      style={{ textTransform: "uppercase" }}
    >
      ASTROLOGIJA v VORTEXU
    </text>

    {/* "Astroloska svetovalka" subtitle */}
    <text
      x="110"
      y="28"
      fontFamily="'Playfair Display', serif"
      fontSize="9"
      fontWeight="400"
      fontStyle="italic"
      fill="#004c6d"
      letterSpacing="0.5"
    >
      Astrološka svetovalka
    </text>
  </svg>
);

export default LogoSVG;
